import { call, put, takeEvery } from "redux-saga/effects"

import {
  POST_GRP_BIRTH_DETAILS,
  GET_REPORT,
  GET_ALL_REPORTS,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN,
  GET_BRANCHES,
  GET_GROUP_USERS,
  GET_GROUP_MASTERS
} from "./actionTypes"

import {
  getAllReportsSuccess,
  getAllReportsFail,
  getReportSuccess,
  getReportFail,
  getBranchesFail,
  getBranchesSuccess,
  getGroupUsersSuccess,
  getGroupUsersFail,
  getGroupMastersSuccess,
  getGroupMastersFail,
} from "./actions"

import {
  postGRPBirthDetails,
  getAllReportForGroupUser,
  getReportForGroupUser,
  getAllReportForGroupAdmin,
  getReportForGroupAdmin,
  getReportForBranchAdmin,
  getGRPBranchesForAutoSuggest,
  getGRPGroupUsersForAutoSuggest,
  getGRPGroupMastersForAutoSuggest,
  getBirthChartForProductAdmin
} from "helpers/backend_helper"

import { isEmpty } from "lodash"

import { getUserRole } from "components/Common/Roles"

import { ROUTER_GROUP } from "helpers/router_helper"

function* postGRPBirthDetailsSaga({ payload: { birthDetail, history } }) {
  console.log("postGRPBirthDetailsSaga->called")
  try {
    const response = yield call(postGRPBirthDetails, birthDetail)
    //yield put(postGRPBirthDetailsSuccess(response))
    history.push({
      pathname: `${ROUTER_GROUP}/generate-report/landing-page`,
      id: response,
      success: true
    })
    console.log("push to: ", `${ROUTER_GROUP}/generate-report/landing-page`)
  } catch (error) {
    let failMsg
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      //yield put(postGRPBirthDetailsFail(error.response.data))
      failMsg = error.response.data
    } else {
      failMsg = error.message
    }
    history.push({
      pathname: '${ROUTER_GROUP}/generate-report/landing-page',
      error: failMsg,
      fail: true
    })
  }
}

// Group User
function* fetchAllReportForGroupUser({ payload }) {
  try {
    console.log("inside fetchAllReportForGroupUser saga updated")
    console.log("payload, ", payload)
    const response = yield call(getAllReportForGroupUser, {
      params: {
        page: payload.page, size: payload.size,
        sortOrder: payload.sortOrder, name: payload.name,
        refferedBy: payload.refferedBy, city: payload.city, mobile: payload.mobile
      }
    })
    // } else if (userRoles.isGRPGroupAdmin) {
    //   console.log("userRoles.isGRPGroupUser")
    //   response = yield call(getAllReportForGroupAdmin, {
    //     params: {
    //       page: payload.page, size: payload.size,
    //       sortOrder: payload.sortOrder
    //     }
    //   })
    // } else if (userRoles.isGRPBranchAdmin) {
    //   return;
    // } else if (userRoles.user) {
    //   return;
    // }
    console.log("response, ", response)
    yield put(getAllReportsSuccess({
      userBirthChartList: response.content,
      page: response.page,
      size: response.size,
      sortOrder: payload.sortOrder,
      totalPages: response.totalPages,
      totalElements: response.totalElements,
      numberOfElements: response.numberOfElements,
    }))
  } catch (error) {
    console.log("error, ", error)
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getAllReportsFail(error.response.data.message))
    } else {
      yield put(getAllReportsFail(error.message))
    }
  }
}

function* fetchReportForGroupUser({ reportId }) {
  try {
    let userRoles;
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }
    if (userRoles.isGRPGroupUser) {
      const response = yield call(getReportForGroupUser, reportId)
      yield put(getReportSuccess(response))
    } else if (userRoles.isGRPGroupAdmin) {
      const response = yield call(getReportForGroupAdmin, reportId)
      yield put(getReportSuccess(response))
    } else if (userRoles.isGRPBranchAdmin) {
      const response = yield call(getReportForBranchAdmin, reportId)
      yield put(getReportSuccess(response))
    } else if (userRoles.productAdmin) {
      const response = yield call(getBirthChartForProductAdmin, {
        params: {
          id: reportId,
          userType: "GROUP",
        }
      })
      yield put(getReportSuccess(response))
    }

  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getReportFail(error.response.data.message))
    } else {
      yield put(getReportFail(error.message))
    }
  }
}


function* fetchReportForGroupAdmin({ payload }) {
  console.log("payload: ", payload)
  try {
    const response = yield call(getAllReportForGroupAdmin, {
      params: {
        page: payload.page, size: payload.size, sortField: '',
        sortOrder: payload.sortOrder, search: '', refferedBy: payload.refferedBy,
        name: payload.name, city: payload.city, mobile: payload.mobile,
        branchId: payload.branchId, userId: payload.groupUserId
      }
    })
    yield put(getAllReportsSuccess({
      userBirthChartList: response.content,
      page: response.page,
      size: response.size,
      sortOrder: payload.sortOrder,
      totalPages: response.totalPages,
      totalElements: response.totalElements,
      numberOfElements: response.numberOfElements,
    }))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getAllReportsFail(error.response.data.message))
    } else {
      yield put(getAllReportsFail(error.message))
    }
  }
}

function* fetchBranches({ groupMastersId }) {
  try {
    let userRoles = getUserRole()
    if (sessionStorage.getItem("authUser")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }

    let userType = null;
    if (userRoles.isGRPGroupAdmin) {
      userType = "GROUP_ADMIN"
    } else if (userRoles.isGRPBranchAdmin) {
      userType = "BRANCH_ADMIN"
    } else if (userRoles.productAdmin) {
      userType = "PRODUCT_ADMIN"
    }

    const response = yield call(getGRPBranchesForAutoSuggest, {
      params: {
        userType: userType,
        id: groupMastersId
      }
    })
    yield put(getBranchesSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getBranchesFail(error.response.data.message))
    } else {
      yield put(getBranchesFail(error.message))
    }
  }
}

function* fetchGroupUsers({ payload: { branchId, userType } }) {
  try {
    const response = yield call(getGRPGroupUsersForAutoSuggest, {
      params: { id: branchId, userType }
    })
    yield put(getGroupUsersSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getGroupUsersFail(error.response.data.message))
    } else {
      yield put(getGroupUsersFail(error.message))
    }
  }
}

function* fetchGroupMasters() {
  try {
    const response = yield call(getGRPGroupMastersForAutoSuggest)
    yield put(getGroupMastersSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(getGroupMastersFail(error.response.data.message))
    } else {
      yield put(getGroupMastersFail(error.message))
    }
  }
}

function* grpReportsSaga() {
  // Group User
  yield takeEvery(GET_REPORT, fetchReportForGroupUser)
  yield takeEvery(POST_GRP_BIRTH_DETAILS, postGRPBirthDetailsSaga)
  yield takeEvery(GET_ALL_REPORTS, fetchAllReportForGroupUser)
  yield takeEvery(GET_ALL_REPORTS_FOR_GROUP_ADMIN, fetchReportForGroupAdmin)
  yield takeEvery(GET_BRANCHES, fetchBranches)
  yield takeEvery(GET_GROUP_USERS, fetchGroupUsers)
  yield takeEvery(GET_GROUP_MASTERS, fetchGroupMasters)
}

export default grpReportsSaga
